<template>
  <div class="scenic-spot">
    <h2 class="title">深圳旅行攻略｜来深圳最值得去的8个地方</h2>
    <div class="item item-one" v-for="(item, index) in data" :key="item.name">
      <div class="item-main-title">{{ item.name }}</div>
      <div class="item-content mgTop22"><span class="content-title">简介：</span></div>
      <div class="mgTop22 item-content">
        <p class="content-text">{{ item.synopsis }}</p>
      </div>
      <div class="item-content mgTop22">
        <span class="content-title">门票：</span>
        <span class="content-text" v-if="index !== 5">{{ item.tickets }}</span>
        <div class="mgTop22 content-text" v-else>{{ item.tickets }}</div>
      </div>
      <div class="item-content mgTop22">
        <span class="content-title">用时：</span>
        <span class="content-text">{{ item.time }}</span>
      </div>
      <div class="item-content mgTop22"><span class="content-title">交通：</span></div>
      <div class="mgTop22 item-content">
        <p class="content-text">{{ item.traffic }}</p>
      </div>
      <div class="item-content mgTop22">
        <span class="content-title">开放时间：</span>
        <span class="content-text">{{ item.disparkTime }}</span>
      </div>
      <div class="item-content mgTop22"><span class="content-title">旅行小贴士：</span></div>
      <div class="mgTop22 item-content">
        <p class="content-text">{{ item.tips }}<span class="text-sign">{{ item.sign }}</span></p>
      </div>
      <div class="item-img mgTop22" v-for="img in item.imgs" :key="img">
        <img :src="img" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import img011 from '@/assets/articleImg/011.jpeg'
import img012 from '@/assets/articleImg/012.jpeg'
import img013 from '@/assets/articleImg/013.jpeg'
import img014 from '@/assets/articleImg/014.jpeg'
import img021 from '@/assets/articleImg/021.jpeg'
import img022 from '@/assets/articleImg/022.jpeg'
import img023 from '@/assets/articleImg/023.jpeg'
import img031 from '@/assets/articleImg/031.jpeg'
import img032 from '@/assets/articleImg/032.jpeg'
import img033 from '@/assets/articleImg/033.jpeg'
import img034 from '@/assets/articleImg/034.jpeg'
import img041 from '@/assets/articleImg/041.jpeg'
import img042 from '@/assets/articleImg/042.jpeg'
import img043 from '@/assets/articleImg/043.jpeg'
import img044 from '@/assets/articleImg/044.jpeg'
import img051 from '@/assets/articleImg/051.jpeg'
import img052 from '@/assets/articleImg/052.jpeg'
import img053 from '@/assets/articleImg/053.jpeg'
import img054 from '@/assets/articleImg/054.jpeg'
import img061 from '@/assets/articleImg/061.jpeg'
import img062 from '@/assets/articleImg/062.jpeg'
import img063 from '@/assets/articleImg/063.jpeg'
import img064 from '@/assets/articleImg/064.jpeg'
import img065 from '@/assets/articleImg/065.jpeg'
import img071 from '@/assets/articleImg/071.jpeg'
import img072 from '@/assets/articleImg/072.jpeg'
import img073 from '@/assets/articleImg/073.jpeg'
import img074 from '@/assets/articleImg/074.jpeg'
import img081 from '@/assets/articleImg/081.jpeg'
import img082 from '@/assets/articleImg/082.jpeg'
import img083 from '@/assets/articleImg/083.jpeg'
import img084 from '@/assets/articleImg/084.jpeg'
export default {
  data () {
    return {
      data: [
        {
          name: 'NO.1 杨梅坑',
          synopsis: '是一处临海的山丘，这里有青山有溪流还有大海，景色很美，被誉为深圳最美的溪谷。由于离市区较远，没有过多开发，还是一片比较原汁原味的休闲之地。因为这里独有的浪漫情调，深圳许多情侣都会选择这里作为婚纱照的外景拍摄地。',
          tickets: '免费',
          time: '3小时以上',
          traffic: '乘坐M274到南澳杨梅坑站。或者先到大鹏，转大鹏新区假日专线3路，在杨梅坑站下车即是。',
          disparkTime: '全天',
          tips: '市区可乘坐E26线---大鹏中心站转M274线---杨梅坑终点站，用”深圳车到哪“APP查询车次行程情况，建议自备水和干粮。杨梅坑全程以观赏性景点为特色，仅有两三处能下水游玩，在公交终点站一直沿道路直行，可到达骑行公路入口。',
          imgs: [img011, img012, img013, img014]
        },
        {
          name: 'NO.2 莲花山公园',
          synopsis: '主峰建有4000平方米的山顶广场，是深圳市内最高的室外广场。瞻仰伟人风采,看城市风貌,俯瞰福田CBD的好地方。全国红色旅游景点之一，深圳市民日常休闲的好去处。',
          tickets: '免费',
          time: '2小时以上',
          traffic: '公交：莲花山公园站（到正门）25路; 25区间线; 38路; 41路; 54区间线; 60路; 65路; 71路; 107路; 215路; 228路; 236路; 322路; 374路; 383路; b686路; k105路; k578路; m372路; m390路; n9路; 高峰专线19路。地铁：龙岗线（3号线）、龙华线（4号线）少年宫站F1出口（直走400米到正门或直走10米右转上台阶到风筝广场）。',
          disparkTime: '06:00-23:00',
          tips: '莲花山公园是深圳最佳观景公园，是去深圳旅游必去的打卡点之一。在这里你可以登山、放风筝、远眺、摄影、看花展、逛公园、看伟人像、看名山、看古树，是休闲的好去处。站在山顶广场，深圳市民广场、中国第一高楼平安大厦、京基101、地王大厦等深圳地标建筑尽收眼底。',
          sign: '该景点不收门票。晚上可以看CBD的灯光秀，大概是七点开始。',
          imgs: [img021, img022, img023]
        },
        {
          name: 'NO.3 大梅沙海滨公园',
          synopsis: '大梅沙海滨公园共分游泳区、运动区、休闲区、娱乐区、烧烤场等区。公园有摩托艇、蹦极、沙滩排球等众多游乐项目，提供购物中心、冲凉寄存、餐饮供应、救生等配套服务。太阳广场属于公园的中心位置，西侧是月亮广场，太阳广场和月亮广场之间有432米长的阳光走廊。公园内一派生机勃勃的亚热带海滨风光，深圳市民和外来游客都很喜欢来这儿享受海滨休闲的时光。',
          tickets: '免费',
          time: '4小时以上',
          traffic: '公交车：387、103、J1、53、242、364、308、观光巴士1路，可在公园的月亮广场或太阳广场下车；208（到总站下车步行5分钟到公园的月亮广场）；360（到梅沙街道办站往盐田方向步行5分钟到公园内的太阳广场）；深圳北站有往东部华侨城旅游专线到海滨浴场下车。',
          disparkTime: '08:00-次日01:00(旺季),08:30-17:30(淡季)',
          tips: '预约才能进园！有两种方法：身份证预约，手机号预约。正门口有明显的预约流程介绍，没带身份证可以用手机号预约的！！！现场预约就可以进去，大梅沙公园是不收取费用的。',
          imgs: [img031, img032, img033, img034]
        },
        {
          name: 'NO.4 梧桐山',
          synopsis: '梧桐山的主要看点是大梧桐和小梧桐两座主峰，大梧桐是深圳第一高峰。小梧桐位于梧桐山北麓的凤谷鸣琴景区内，沿着山脊有一条观景走廊，这里山势不高而且比较好走，适合各个年龄层的游客来此登高望远。梧桐山最美的景色就要数这些从海上飘来的云雾，由山顶常常云雾缭绕，因此又有“雾锁梧桐”的称呼。景区内另一个比较值得一看的点是仙湖植物园，除了植物以外，植物园内还有深圳香火最旺的寺院之一弘法寺。',
          tickets: '免费',
          time: '6小时以上',
          traffic: '乘坐公交211路可到梧桐山总站。',
          disparkTime: '06:00-19:00',
          tips: '深圳第一高峰，海拔900多米，上路中间有很多溪水，树荫也比较浓密，所以爬起来不觉得热。只有临近山顶的时候，大概有半个小时的路程是石阶，难度较大。全程上下大约要花五六个小时。',
          imgs: [img041, img042, img043, img044]
        },
        {
          name: 'NO.5 深圳湾公园',
          synopsis: '由已开放的红树林海滨生态公园和建设中的深圳湾滨海休闲带两部分组成。依着美丽的滨海大道而建，靠着大海，面朝香港，是散步、周末游玩的好地方。在这里徒步和骑自行车都不错，滨海自行车带全长达13公里之长，但园内禁止机动车行驶。',
          tickets: '免费',
          time: '2小时以上',
          traffic: '乘坐地铁9号线至深圳湾公园(地铁站)下，步行即可到达。',
          disparkTime: '全天开放',
          tips: '深圳出地铁看到海的地方从地铁9号线深圳湾公园站D2口出，上完电梯就可以看到大海了，真的超赞!一望无际的大海，长长的海滨道，来此散步骑车的人真不少，天气好的时候还有成群的海鸥，浪漫极了!这里是看海最近的地方，来深圳一定要过来！',
          imgs: [img051, img052, img053, img054]
        },
        {
          name: 'NO.6 深圳世界之窗',
          synopsis: '把世界奇观、历史遗迹、古今名胜、民间歌舞表演融为一体的人造主题公园。世界之窗分为世界广场、亚洲区、欧洲区、非洲区、美洲区等八大区域。公园将历史遗迹、名胜、自然风光、世界奇观、民居、雕塑等130多个景点按不同比例仿建。还有民间歌舞、大型演出以及高科技参与性娱乐项目等，晚上还有夜场，活动非常丰富。',
          tickets: '日场票:220人民币；夜场票:100人民币 。半票:65周岁(含)至69周岁(含)老年人。免票:70周岁(含)以上老年人。tips:在购票和入闸时须出示身份证、护照等有效证件。持《深圳市敬老优待证》的深圳户籍长者可享受免票优待，闸口必要时可查验长者身份证。',
          time: '3小时以上',
          traffic: '地铁1、2号线至世界之窗下车；公交市内乘坐204,M388、222、223、230、232、234、245、M413、323、324、327、329,369路等公交车至世界之窗站下车。',
          disparkTime: '09:00-22:00(平日),09:00-22:30(节假日) (1月1日-12月31日 周一-周日)。tips:如遇大型活动，时间可能有变，具体开闭园时间详情以官网为准阿尔卑斯冰雪世界平日开放时间为10:00-21:00，节假日开放时间为10:00-21:30夜场入园时间为19:30。',
          tips: '深圳的标志性景点，景区内有供租用的代步车，180一小时。景区内几乎囊括世界上所有的著名景点，大多是采用1：13微缩，也有部分是1：1比例建成，比较多人的打卡点有埃菲尔铁塔、白宫、比萨斜塔、金字塔、泰姬陵等。',
          imgs: [img061, img062, img063, img064, img065]
        },
        {
          name: 'NO.7 何香凝美术馆',
          synopsis: '何香凝美术馆是中国第一个以个人名字命名的国家级美术馆，也是继中国美术馆之后的第二个国家现代博物馆。何香凝美术馆坐落在中国改革开放的窗口城市- 深圳 -华侨城，毗邻驰名中外的三大文化旅游景区锦绣中华、中国民俗文化村、世界之窗，和民俗文化村西门入口紧相连。美术馆主要是收藏、陈列、研究何香凝的书画作品，也举办美术展览。何香凝（1878－1972），廖仲恺夫人，杰出的革命家 和政 治活动家， 中国著名画家。作为中国革命的元老级人物，何香凝一直没有放下画笔，早期作品有浓厚的日本画风格，她以梅花和老虎为题材的绘画作品享誉海内外。她擅作花鸟，偶作山水，笔致圆浑细腻，色彩古艳雅逸，意态生动。擅长中国画。作品有《狮》《梅花》《高松图》等，曾出版画集有《何香凝画集》、《何香凝诗画辑》、《双清诗画集》等。',
          tickets: '免费',
          time: '2小时以上',
          traffic: '公交：乘坐地铁1号线在华侨城站下，下车后步行可达。',
          disparkTime: '周二至周日，9:30-17:00（16:30停止入馆），周一闭馆（节假日除外，特殊情况会在官网通知）',
          tips: '馆内巧妙运用了“天井”的设计，天花板也尽量打通了天窗，自然光柔和地洒满了整个室内空间。内部采用中式栏杆和木棂窗门，带有一点古风的感觉，又有大量的留白，传统朴素又不失美感。展品也很有层次性地展示了何香凝先生的大师风采。一句“腕底烟云未等闲”，就透出了她作为一名艺术家、社会活动家的巾帼气度。',
          imgs: [img071, img072, img073, img074]
        },
        {
          name: 'NO.8 西涌海滩',
          synopsis: '西涌海滩是深圳最长的海滩，这里的景色被誉为中国最美的海景之一。长达10里的海滩如绸缎般飘逸、舒畅，山、海、湖、岬角风光旖旎。大鹏半岛最南端的原生态海滨浴场，海水清澈，适合下海游泳、休闲度假。目前有快艇出海、沙滩烧烤、钓鱼、篝火晚会、东西冲穿越等娱乐项目。',
          tickets: '具体请咨询景区',
          time: '4小时以上',
          traffic: '深圳-西涌：深圳市区乘e11路到南澳总站 ，换乘m232路至三四号收费站下车即是。银湖-南澳镇：7号车下车后走过隔壁的小巴总站坐360号空调大巴，全程17元。过盐田港后沿途风景不错，需时约2小时。南澳镇-西涌海滩：租小面的5元/人，可以坐6人，但包大极挤，需时约20分钟。',
          disparkTime: '09:00-22:00(平日),09:00-22:30(节假日) (1月1日-12月31日 周一-周日)。tips:如遇大型活动，时间可能有变，具体开闭园时间详情以官网为准阿尔卑斯冰雪世界平日开放时间为10:00-21:00，节假日开放时间为10:00-21:30夜场入园时间为19:30。',
          tips: '西涌沙滩分别由4个收费沙滩入口，其中1号沙滩位于正中间位置，风景、沙滩、游泳的水质均为最佳，其对面的南社村更是民宿客栈最为集中的地方。夏季西涌海滨浴场实行收费管理，成人13元/人，1.2米以上的未成年人半价，1.2以下儿童免费。浴场游泳时间为：早上9:00--晚上7:30，这期间游客可以下海畅游，其他时间禁止下海游泳，但可以在海滩上玩耍，戏水。（最佳游泳时间：下午4:00-7:30；上午9:00-10:30）。东面为出海口 ，海水清澈，海浪较大，非常适合冲浪、摩托艇等水上项目。西冲沙滩算是深圳东部的一块“处女地”吧，未被过度开发，海水干净，沙子柔软。1号沙滩：沙滩宽，海水浅，适合孩子，可以捡贝壳和寄居蟹，适合沙滩篝火。',
          imgs: [img081, img082, img083, img084]
        }
      ]
    }
  }
}
</script>
<style lang="less" scoped>
p {
  margin: 0;
}
h2 {
  margin: 0;
  font-size: 57.6px;
  font-weight: 700;
}
.mgTop22 {
  margin-top: 35.2px;
}
.scenic-spot {
  padding: 48px;
  .item {
    .item-main-title {
      margin-top: 70.4px;
      position: relative;
      padding-left: 28.8px;
      font-size: 57.6px;
      &:before {
        content: "";
        display: inline-block;
        height: 51.2px;
        width: 16px;
        background-color: #4e6ef2;
        position: absolute;
        top: 50%;
        left: 0;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        border-radius: 8px;
      }
    }
    .item-content {
      .content-title {
        font-size: 57.6px;
        color: #333;
        font-weight: 700;
      }
      .content-text {
        font-size: 51.2px;
        line-height: 76.8px;
        color: #333;
        text-align: justify;
        .text-sign {
          font-size:  51.2px;
          color: #333;
          font-weight: 700;
        }
      }
    }
    .item-img {
      width: 100%;
      >img {
        width: 100%;
      }
    }
  }
}
</style>
